<template>
  <div id="app">
    <Mobile/>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Mobile from '@/components/MobileModule.vue'

  export default {
    name: 'App',
    data (){
      return {
        isRouterAlive: true
      }
    },
    provide() {
      return {
        reload: this.reload
      }
    },
    mounted() {
      this.HEIGHT_VIEW()
    },
    computed: {
      ...mapGetters(['innerHeightRem']),
      boxHeightRem () {
        return this.innerHeightRem
      },
      winInnHeight () {
        if (window.innerHeight) {
          return window.innerHeight
        }
        return 0
      },
      IsPC () { // 判断移动端
        let userAgentInfo = navigator.userAgent
        let Agents = new Array('Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod')
        let flag = true
        for (let v = 0; v < Agents.length; v++) {
          if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false
            break
          }
        }
        return flag
      }
    },
    components: {
      Mobile
    },
    methods: {
      reload(){
        this.isRouterAlive = false
        this.$nextTick(function(){
          this.isRouterAlive = true
        })
      },
      getPlatform () {
        return /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent) ? -1 != navigator.userAgent.indexOf("cordova") && -1 != navigator.userAgent.indexOf("iphone") ? "ios" : -1 != navigator.userAgent.indexOf("cordova") && -1 != navigator.userAgent.indexOf("android") ? "android" : -1 != navigator.userAgent.indexOf("MicroMessenger") ? "wechat" : "wap" : "pc"
      },
      getQueryString (name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]);
        return null;
      },
    }
  }
</script>
